export default "__VITE_PUBLIC_ASSET__30f368e7__"